export default __webpack_public_path__ + "pgnv-assets/7d2f077ca38ed701e9bdb81e96db4dc0.png";